import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import IButton from '@/js/components/molecules/IButton.vue';
import ITextArea from '@/js/components/molecules/ITextArea.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageComment',
  props: {
    url: null,
    text: { default: '' }
  },
  emits: ["cancel", "save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'cancel'): void;
  (e: 'save', comment: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { url: string, text: string };



const observer = ref();
const comment = ref(props.text);
const cancel = () => {
  comment.value = props.text;
  emit('cancel');
};
const save = async () => {
  const isValid = await observer.value.validate();
  if (isValid) {
    emit('save', comment.value);
  }
};

return { __sfc: true,props, emit, observer, comment, cancel, save, IButton, ITextArea }
}

})